import React, { useState, useEffect, useRef } from 'react'
import { useParams,useNavigate, NavLink } from 'react-router-dom';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import  { GetQuestionById }  from '../../controllers/GetQuestionById';
import  { GetCourseChild }  from '../../controllers/GetCourseChild';
import  { GetQuestionCourseLevel }  from '../../controllers/GetQuestionCourseLevel';
import  { GetCourseFather }  from '../../controllers/GetCourseFather';
import { Navbar } from '../ui/NavBar';
import  { CourseEnding }  from '../../controllers/CourseEnding';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import {encode as base64_encode} from 'base-64';
import  { PositionUpdate }  from '../../controllers/PositionUpdate';
import  { positionByCourse }  from '../../controllers/positionByCourse';
import { Button } from "@wfp/ui";

// Home to display "Pregunta"
export const QuestionOK = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }

    const [questionDes, setQuestionDes] = useState("");
    const [nameUnit, setNameUnit] = useState("");
    const { fatherId } = useParams();
    const { unitId } = useParams();
    const { questionId } = useParams();
    const cursoId = localStorage.getItem('courseId');
    const cursoColor = localStorage.getItem('courseColor');
    const [url, setUrl] = useState('');
    const [cursoNombre, setCursoNombre] = useState('');
    const [imgBackType, setImgBackType] = useState(false);
    const [imgBack, setImgBack] = useState('');
    const [loading, setLoading] = useState(true);
    const loader = useRef(null);
    let listUnit = [];
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    let ran = false;
    useEffect(() => {
        if (ran) return;
            setImgBackType(JSON.parse(window.localStorage.getItem('edufami_feedback_correct')).image_type)
            setImgBack(JSON.parse(window.localStorage.getItem('edufami_feedback_correct')).image_value)
            GetQuestionById(questionId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                // console.log(e[0])
                setQuestionDes(e[0].feedback_correct)
            })
            .catch((e)=>{
                console.error(e);
                //dispatch(logout(token));
            });
            GetCourseChild(cursoId, user.languaje, token, user.id, fatherId)
            .then((res)=>{
                res.sort((a, b) => a.id - b.id);
                let found = res.find(element => element?.id === parseInt(unitId));
                console.log({found},0)
                if(found.question_numbers > 1){
                    GetQuestionCourseLevel(unitId, user.languaje, token, user.id)
                    .then((e)=>{
                        e.sort((a, b) => a.id - b.id);
                        let enterQ = 0;
                        e.forEach(element => {
                            if(element.id > parseInt(questionId) && enterQ === 0){
                                enterQ++;
                                setUrl(`/question/${fatherId}/${unitId}/${element.id}`)
                            }
                        });
                        // console.log('1',enterQ, url)
                        console.log('1')
                        if(enterQ === 0){
                            console.log('2')
                            if(localStorage.getItem('gChildFather')){
                                console.log('3')
                                setUrl(`/gchild/${localStorage.getItem('gChildFather')}/${fatherId}`)
                                if( found && found.ending_id === null ){
                                    CourseEnding(token, user.id, unitId)
                                    .catch((e)=>{
                                        console.error(e);
                                        dispatch(logout(token));
                                    });
                                }
                                let enterGCUQ = 0;
                                if(res.length > 1){
                                    res.forEach((element, index, arr) => {
                                        if (index !== arr.length - 1) {
                                            if(!element.ending_id){
                                                enterGCUQ++;
                                            }
                                        }
                                    });
                                }
                                if(enterGCUQ === 0){
                                    console.log('4')
                                    setUrl(`/child/${localStorage.getItem('childFather')}/${localStorage.getItem('gChildFather')}`)
                                    GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('gChildFather'))
                                    .then((e)=>{
                                        let found = e.find(element => element?.id === parseInt(fatherId));
                                        if( found && found.ending_id === null ){
                                            CourseEnding(token, user.id, fatherId)
                                            .catch((e)=>{
                                                console.error(e);
                                                dispatch(logout(token));
                                            });
                                        }
                                        let enterUQ = 0;
                                        if(res.length > 1){
                                            res.forEach((element, index, arr) => {
                                                if (index !== arr.length - 1) {
                                                    if(!element.ending_id){
                                                        enterUQ++;
                                                    }
                                                }
                                            });
                                        }
                                        if(enterUQ === 0){
                                            console.log('5')
                                            setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                            GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                            .then((e)=>{
                                                let found = e.find(element => element?.id === parseInt(localStorage.getItem('gChildFather')));
                                                if( found && found.ending_id === null ){
                                                    CourseEnding(token, user.id, localStorage.getItem('gChildFather'))
                                                    .catch((e)=>{
                                                        console.error(e);
                                                        dispatch(logout(token));
                                                    });
                                                }
                                                let enterQF = 0;
                                                e.forEach(element => {
                                                    if(!element.ending_id){
                                                        enterQF++;
                                                    }
                                                });
                                                if(enterQF === 0){
                                                    console.log('6')
                                                    setUrl(`/course/${cursoId}`)
                                                    GetCourseFather(cursoId, user.languaje, token, user.id)
                                                    .then((e)=>{
                                                        let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));
                                                        
                                                        if( found && found.ending_id === null ){
                                                            CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                            .catch((e)=>{
                                                                console.error(e);
                                                                dispatch(logout(token));
                                                            });
                                                            const lastElement = e.pop();
                                                            if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                                setUrl(`/finish/${cursoId}`);
                                                            }
                                                        }
                                                        let found1 = e.find(element => element && element?.ending_id === null);
                                                        if(typeof found1 === 'undefined' ){
                                                            setUrl(`/finish/${cursoId}`);
                                                        }
                                                        
                                                        positionByCourse( token, user.id, cursoId)
                                                        .then((e)=>{
                                                            // console.log({e})
                                                            PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                                            .catch((e)=>{
                                                                console.error(e);
                                                                // dispatch(logout(token));
                                                            });
                                                        })
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            // dispatch(logout(token));
                                                        });
                                                    })
                                                    .catch((e)=>{
                                                        console.error(e);
                                                        //dispatch(logout(token));
                                                    });
                                                    
                                                }
                                            })
                                            .catch((e)=>{
                                                console.error(e);
                                                //dispatch(logout(token));
                                            });
                                            
                                        }
                                    })
                                    .catch((e)=>{
                                        console.error(e);
                                        // dispatch(logout(token));
                                    });
                                }        
                            }
                            else if(localStorage.getItem('childFather')){
                                console.log('7')
                                setUrl(`/child/${localStorage.getItem('childFather')}/${fatherId}`)
                                // console.log('2',enterQ, url)
                                if( found && found.ending_id === null ){
                                    CourseEnding(token, user.id, unitId)
                                    .catch((e)=>{
                                        console.error(e);
                                        dispatch(logout(token));
                                    });
                                }
                                let enterUQ = 0;
                                if(res.length > 1){
                                    res.forEach((element, index, arr) => {
                                        if (index !== arr.length - 1) {
                                            if(!element.ending_id){
                                                enterUQ++;
                                            }
                                        }
                                    });
                                }
                                if(enterUQ === 0){
                                    console.log('8')
                                    setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                    GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                    .then((e)=>{
                                        let found = e.find(element => element?.id === parseInt(fatherId));
                                        if(found?.ending_id === null ){
                                            console.log({found}, '1')
                                            CourseEnding(token, user.id, fatherId)
                                            .catch((e)=>{
                                                console.error(e);
                                                dispatch(logout(token));
                                            });
                                        }
                                        let enterQF = 0;
                                        e.forEach(element => {
                                            if(!element.ending_id){
                                                enterQF++;
                                            }
                                        });
                                        if(enterQF === 0){
                                            console.log('9')
                                            setUrl(`/course/${cursoId}`)
                                            GetCourseFather(cursoId, user.languaje, token, user.id)
                                            .then((e)=>{
                                                let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));

                                                if(found?.ending_id === null ){
                                                    console.log({found},'2')
                                                    CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                    .catch((e)=>{
                                                        console.error(e);
                                                        dispatch(logout(token));
                                                    });
                                                    const lastElement = e.pop();
                                                    if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                        setUrl(`/finish/${cursoId}`);
                                                    }
                                                }
                                                let found1 = e.find(element => element && element?.ending_id === null);
                                                if(typeof found1 === 'undefined' ){
                                                    setUrl(`/finish/${cursoId}`);
                                                }
                                            
                                                positionByCourse( token, user.id, cursoId)
                                                .then((e)=>{
                                                    // console.log({e})
                                                    PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                                    .catch((e)=>{
                                                        console.error(e);
                                                        // dispatch(logout(token));
                                                    });
                                                })
                                                .catch((e)=>{
                                                    console.error(e);
                                                    // dispatch(logout(token));
                                                });
                                            })
                                            .catch((e)=>{
                                                console.error(e);
                                                //dispatch(logout(token));
                                            });
                                            
                                        }
                                    })
                                    .catch((e)=>{
                                        console.error(e);
                                        //dispatch(logout(token));
                                    });
                                    
                                }
                            }
                            else if(localStorage.getItem('lessonFather')){
                                console.log('10')
                                setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${fatherId}`)
                                if( found && found.ending_id === null ){
                                    console.log({found},'3')
                                    CourseEnding(token, user.id, unitId)
                                    .catch((e)=>{
                                        console.error(e);
                                        dispatch(logout(token));
                                    });
                                }
                                let enterUQ = 0;
                                if(res.length > 1){
                                    res.forEach((element, index, arr) => {
                                        if (index !== arr.length - 1) {
                                            if(!element.ending_id){
                                                enterUQ++;
                                            }
                                        }
                                    });
                                }
                                if(enterUQ === 0){
                                    console.log('11')
                                    setUrl(`/course/${cursoId}`)
                                    GetCourseFather(cursoId, user.languaje, token, user.id)
                                    .then((e)=>{
                                        let found = e.find(element => element?.id === parseInt(fatherId));
                                        if( found && found.ending_id === null ){
                                            console.log({found},'4')
                                            CourseEnding(token, user.id, fatherId)
                                            .catch((e)=>{
                                                console.error(e);
                                                dispatch(logout(token));
                                            });
                                            const lastElement = e.pop();
                                            if(lastElement.id === parseInt(fatherId)){
                                                setUrl(`/finish/${cursoId}`);
                                            }
                                        }
                                        let found1 = e.find(element => element && element?.ending_id === null);
                                        if(typeof found1 === 'undefined' ){
                                            setUrl(`/finish/${cursoId}`);
                                        }
                                        
                                        positionByCourse( token, user.id, cursoId)
                                        .then((e)=>{
                                            // console.log({e})
                                            PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                            .catch((e)=>{
                                                console.error(e);
                                                // dispatch(logout(token));
                                            });
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            // dispatch(logout(token));
                                        });
                                    })
                                    .catch((e)=>{
                                        console.error(e);
                                        //dispatch(logout(token));
                                    });
                                            
                                }
                            }
                            else{
                                console.log('12')
                                setUrl(`/course/${cursoId}`);
                                positionByCourse( token, user.id, cursoId)
                                .then((e)=>{
                                    // console.log({e})
                                    PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                    .catch((e)=>{
                                        console.error(e);
                                        // dispatch(logout(token));
                                    });
                                })
                                .catch((e)=>{
                                    console.error(e);
                                    // dispatch(logout(token));
                                });
                            }
                        }
                    })
                    .catch((e)=>{
                        console.error(e);
                        //dispatch(logout(token));
                    });
                    
                }
                else{
                    console.log('13')
                    GetQuestionCourseLevel(unitId, user.languaje, token, user.id)
                    .then((e)=>{
                        let enterQ = 0;
                        e.forEach(element => {
                            if(element.id > parseInt(questionId) && enterQ === 0){
                                enterQ++;
                                setUrl(`/question/${fatherId}/${unitId}/${element.id}`)
                            }
                        });
                        
                        if(enterQ === 0){
                            console.log('14')
                            setUrl(`/child/${localStorage.getItem('childFather')}/${fatherId}`)
                            if( found && found.ending_id === null ){
                                CourseEnding(token, user.id, unitId)
                               .catch((e)=>{
                                   console.error(e);
                                   dispatch(logout(token));
                               });
                            }
                            let enterUQ = 0;
                            if(res.length > 1){
                                res.forEach((element, index, arr) => {
                                    if (index !== arr.length - 1) {
                                        if(!element.ending_id){
                                            enterUQ++;
                                        }
                                    }
                                });
                            }
                            if(enterUQ === 0){
                                console.log('15')
                                if(localStorage.getItem('gChildFather')){
                                    console.log('16')
                                    setUrl(`/gchild/${localStorage.getItem('gChildFather')}/${fatherId}`)
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, unitId)
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    let enterGCUQ = 0;
                                    if(res.length > 1){
                                        res.forEach((element, index, arr) => {
                                            if (index !== arr.length - 1) {
                                                if(!element.ending_id){
                                                    enterGCUQ++;
                                                }
                                            }
                                        });
                                    }
                                    if(enterGCUQ === 0){
                                        console.log('17')
                                        setUrl(`/child/${localStorage.getItem('childFather')}/${localStorage.getItem('gChildFather')}`)
                                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('gChildFather'))
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(fatherId));
                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, fatherId)
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                            }
                                            let enterUQ = 0;
                                            if(res.length > 1){
                                                res.forEach((element, index, arr) => {
                                                    if (index !== arr.length - 1) {
                                                        if(!element.ending_id){
                                                            enterUQ++;
                                                        }
                                                    }
                                                });
                                            }
                                            if(enterUQ === 0){
                                                console.log('18')
                                                setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                                GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                                .then((e)=>{
                                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('gChildFather')));
                                                    if( found && found.ending_id === null ){
                                                        CourseEnding(token, user.id, localStorage.getItem('gChildFather'))
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            dispatch(logout(token));
                                                        });
                                                    }
                                                    let enterQF = 0;
                                                    e.forEach(element => {
                                                        if(!element.ending_id){
                                                            enterQF++;
                                                        }
                                                    });
                                                    if(enterQF === 0){
                                                        console.log('19')
                                                        setUrl(`/course/${cursoId}`)
                                                        GetCourseFather(cursoId, user.languaje, token, user.id)
                                                        .then((e)=>{
                                                            let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));
                                                            
                                                            if( found && found.ending_id === null ){
                                                                CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                                .catch((e)=>{
                                                                    console.error(e);
                                                                    dispatch(logout(token));
                                                                });
                                                                const lastElement = e.pop();
                                                                if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                                    setUrl(`/finish/${cursoId}`);
                                                                }
                                                            }
                                                            let found1 = e.find(element => element && element?.ending_id === null);
                                                            if(typeof found1 === 'undefined' ){
                                                                setUrl(`/finish/${cursoId}`);
                                                            }
                                                            
                                                            positionByCourse( token, user.id, cursoId)
                                                            .then((e)=>{
                                                                // console.log({e})
                                                                PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                                                .catch((e)=>{
                                                                    console.error(e);
                                                                    // dispatch(logout(token));
                                                                });
                                                            })
                                                            .catch((e)=>{
                                                                console.error(e);
                                                                // dispatch(logout(token));
                                                            });
                                                        })
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            //dispatch(logout(token));
                                                        });
                                                        
                                                    }
                                                })
                                                .catch((e)=>{
                                                    console.error(e);
                                                    //dispatch(logout(token));
                                                });
                                                
                                            }
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            // dispatch(logout(token));
                                        });
                                    }        
                                }
                                else if(localStorage.getItem('childFather')){
                                    console.log('20')
                                    setUrl(`/child/${localStorage.getItem('childFather')}/${fatherId}`)
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, unitId)
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    let enterUQ = 0;
                                    if(res.length > 1){
                                        res.forEach((element, index, arr) => {
                                            if (index !== arr.length - 1) {
                                                if(!element.ending_id){
                                                    enterUQ++;
                                                }
                                            }
                                        });
                                    }
                                    if(enterUQ === 0){
                                        console.log('21')
                                        setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${localStorage.getItem('childFather')}`)
                                        GetCourseChild(cursoId, user.languaje, token, user.id, localStorage.getItem('childFather'))
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(fatherId));
                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, fatherId)
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                            }
                                            let enterQF = 0;
                                            e.forEach(element => {
                                                if(!element.ending_id){
                                                    enterQF++;
                                                }
                                            });
                                            if(enterQF === 0){
                                                console.log('22')
                                                setUrl(`/course/${cursoId}`)
                                                GetCourseFather(cursoId, user.languaje, token, user.id)
                                                .then((e)=>{
                                                    let found = e.find(element => element?.id === parseInt(localStorage.getItem('childFather')));
                                                    
                                                    if( found && found.ending_id === null ){
                                                        CourseEnding(token, user.id, localStorage.getItem('childFather'))
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            dispatch(logout(token));
                                                        });
                                                        const lastElement = e.pop();
                                                        if(lastElement.id === parseInt(localStorage.getItem('childFather'))){
                                                            setUrl(`/finish/${cursoId}`);
                                                        }
                                                    }
                                                    let found1 = e.find(element => element && element?.ending_id === null);
                                                    if(typeof found1 === 'undefined' ){
                                                        setUrl(`/finish/${cursoId}`);
                                                    }
                                                    
                                                    positionByCourse( token, user.id, cursoId)
                                                    .then((e)=>{
                                                        // console.log({e})
                                                        PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                                        .catch((e)=>{
                                                            console.error(e);
                                                            // dispatch(logout(token));
                                                        });
                                                    })
                                                    .catch((e)=>{
                                                        console.error(e);
                                                        // dispatch(logout(token));
                                                    });
                                                })
                                                .catch((e)=>{
                                                    console.error(e);
                                                    //dispatch(logout(token));
                                                });
                                                
                                            }
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                        
                                    }
                                }
                                else if(localStorage.getItem('lessonFather')){
                                    console.log('23')
                                    setUrl(`/lessons/${localStorage.getItem('lessonFather')}/${fatherId}`)
                                    if( found && found.ending_id === null ){
                                        CourseEnding(token, user.id, unitId)
                                        .catch((e)=>{
                                            console.error(e);
                                            dispatch(logout(token));
                                        });
                                    }
                                    let enterUQ = 0;
                                    if(res.length > 1){
                                        res.forEach((element, index, arr) => {
                                            if (index !== arr.length - 1) {
                                                if(!element.ending_id){
                                                    enterUQ++;
                                                }
                                            }
                                        });
                                    }
                                    if(enterUQ === 0){
                                        console.log('24')
                                        setUrl(`/course/${cursoId}`)
                                        GetCourseFather(cursoId, user.languaje, token, user.id)
                                        .then((e)=>{
                                            let found = e.find(element => element?.id === parseInt(fatherId));

                                            if( found && found.ending_id === null ){
                                                CourseEnding(token, user.id, fatherId)
                                                .catch((e)=>{
                                                    console.error(e);
                                                    dispatch(logout(token));
                                                });
                                                const lastElement = e.pop();
                                                if(lastElement.id === parseInt(fatherId)){
                                                    setUrl(`/finish/${cursoId}`);
                                                }
                                            }
                                            let found1 = e.find(element => element && element?.ending_id === null);
                                            if(typeof found1 === 'undefined' ){
                                                setUrl(`/finish/${cursoId}`);
                                            }
                                            
                                            positionByCourse( token, user.id, cursoId)
                                            .then((e)=>{
                                                // console.log({e})
                                                PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                                .catch((e)=>{
                                                    console.error(e);
                                                    // dispatch(logout(token));
                                                });
                                            })
                                            .catch((e)=>{
                                                console.error(e);
                                                // dispatch(logout(token));
                                            });
                                        })
                                        .catch((e)=>{
                                            console.error(e);
                                            //dispatch(logout(token));
                                        });
                                                
                                    }
                                }
                                else{
                                    console.log('25')
                                    setUrl(`/course/${cursoId}`);
                                    positionByCourse( token, user.id, cursoId)
                                    .then((e)=>{
                                        // console.log({e})
                                        PositionUpdate( token, user.id, cursoId, `/units/${cursoId}`, e[0].id)
                                        .catch((e)=>{
                                            console.error(e);
                                            // dispatch(logout(token));
                                        });
                                    })
                                    .catch((e)=>{
                                        console.error(e);
                                        // dispatch(logout(token));
                                    });
                                }
                            }
                        }
                    })
                    .catch((e)=>{
                        console.error(e);
                        //dispatch(logout(token));
                    });
                    
                }
                setNameUnit(found.text_value)
                setLoading(false);
            })
            .catch((e)=>{
                console.error(e);
                //dispatch(logout(token));
            });

            setCursoNombre(window.localStorage.getItem(`courseName`))
        
        return () => (ran = true);
    }, [cursoId])

    let img_wrong = `${process.env.REACT_APP_PRD_URL}/assets/answ_ok.png`;
    const disCourse = ()=>{

                return (<>
                    <div className="cont-fail"><img src={img_wrong} alt={nameUnit} className="wrong-answer" /></div>

                    <div className="question-tip" style={{whiteSpace: 'pre-line'}}>{questionDes}</div>

                    <div className="course-enter-q-a">
                        <NavLink to={ url } className="wfp--link">
                            <Button
                                    id="btnIngresar"
                                    type="submit"
                                    className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary"
                                    style={{
                                        borderColor:  cursoColor,
                                        backgroundColor: cursoColor,
                                        color:  "#ffffff",
                                    }}
                                >
                                    {transTxt.btn.continuar.txt}
                            </Button>
                        </NavLink>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    </>);

    }
    
    return (
        <div className="fund-main-course-ok">
            {
                    imgBackType && (imgBackType==="svg")
                    ?
                    <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                    :(imgBackType!==null)?
                    <img className="fund-start-b-img" src = {`data:image/${imgBackType}+xml;base64,${btoa(imgBack)}`} alt="Back Ground"/>
                    : null
                } 
            <Navbar title={cursoNombre}/>
            
            <div className="fund-ok-question">
                <div className="text-title"
                style={{
                    backgroundColor: cursoColor,
                    color:  "#ffffff",
                }}
                >{nameUnit && nameUnit}</div>
                <div className="content-questions" >
 
                <div className="container-question">
                {loading && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}
                    { !loading && listUnit && disCourse() }
                </div>
                
                </div>
                <div ref={loader} />
            </div>
        </div>
    )
}
